import '../../styles/global.css';

/**
 * Brings in the tokens, the reset and the brand font once. Render it at the root (or import
 * `@pidelo/web-ui/global.css`); it draws nothing.
 */
export function GlobalStyles() {
  return null;
}
